(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var COLLAPSED_HEIGHT = 250;

  function initDescToggle(wrap) {
    var el  = wrap.querySelector('.desc-collapse');
    var btn = wrap.querySelector('.desc-toggle');
    if (!el || !btn) return;

    if (el.scrollHeight <= COLLAPSED_HEIGHT) {
      el.style.maxHeight = 'none';
      el.classList.add('is-expanded');
      btn.classList.add('desc-toggle--hidden');
      return;
    }

    btn.addEventListener('click', function () {
      var expanded = el.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', String(expanded));
      btn.innerHTML = expanded
        ? 'Show less <span class="desc-toggle__icon" aria-hidden="true">↑</span>'
        : 'Read more <span class="desc-toggle__icon" aria-hidden="true">↓</span>';
    });
  }

  function initAll() {
    document.querySelectorAll('.desc-collapse-wrap').forEach(initDescToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["xq-routine-quiz"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('xq-routine-quiz')){
class XqRoutineQuiz extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.copy=JSON.parse(this.querySelector('[data-quiz-language]').textContent);this.answers=[];this.addEventListener('click',e=>{const option=e.target.closest('[data-choice]');if(option){this.answers.push(option.dataset.choice);this.render(true)}if(e.target.closest('[data-back]')){this.answers.pop();this.render(true)}if(e.target.closest('[data-restart]')){this.answers=[];this.render(true)}});this.querySelector('form').addEventListener('submit',()=>{try{sessionStorage.setItem('xq-routine-answers',JSON.stringify(this.answers))}catch(e){}});if(this.querySelector('[data-signup-success],.errors')){try{const a=JSON.parse(sessionStorage.getItem('xq-routine-answers')||'[]');if(Array.isArray(a))this.answers=a}catch(e){}}this.render(false)}
render(focus){const c=this.copy,a=this.answers,category=c.categories.find(x=>x.key===a[0]);let question,options;if(!category){a.length=0;question=c.q1;options=c.categories}else if(a.length===1){question=category.question;options=category.options}else if(a.length===2&&(category.key==='skin'||category.key==='hair')){question=category.routine;options=c.routines}else{this.showResult(category,focus);return}this.querySelector('[data-questions]').hidden=false;this.querySelector('[data-result]').hidden=true;this.querySelector('[data-back]').hidden=a.length===0;this.closest('section').querySelector('[data-quiz-progress]').textContent=String(a.length+1);this.querySelector('[data-question]').textContent=question;const list=this.querySelector('[data-options]');list.replaceChildren();options.forEach(o=>{const b=document.createElement('button');b.type='button';b.dataset.choice=o.key;b.textContent=o.label;list.append(b)});if(focus)this.querySelector('[data-question]').focus()}
showResult(category,focus){const a=this.answers,c=this.copy;let key=category.key;if(category.key==='skin'){if(['hydration','everyday'].includes(a[1])&&a[2]==='two')key='daily';else if(a[1]==='radiance')key='radiance';else if(a[1]==='age')key='age';else key='skin'}if(category.key==='hair'&&['scalp','fullness'].includes(a[1])&&a[2]==='two')key='rosemary';if(category.key==='gifting'&&a[1]==='fragrance')key='fragrance';if(category.key==='gifting'&&a[1]==='card')key='giftcard';if(category.key==='mens'&&a[1]==='beard')key='beard';const r=c.results[key];this.querySelector('[data-questions]').hidden=true;this.querySelector('[data-result]').hidden=false;this.querySelector('[data-result-title]').textContent=r.title;this.querySelector('[data-result-copy]').textContent=r.text;this.querySelector('[data-result-link]').href=r.url;this.querySelector('[data-fragrance]').hidden=key!=='daily';const tag=this.querySelector('[data-interest-tag]');if(tag)tag.value='newsletter,routine_quiz,'+r.tag;this.dataset.resultKey=key;this.dispatchEvent(new CustomEvent('xq:result'));this.closest('section').querySelector('[data-quiz-progress]').textContent='✓';if(focus)this.querySelector('[data-result-title]').focus()}
}customElements.define('xq-routine-quiz',XqRoutineQuiz)}

  } catch(e) { console.error(e); }
})();
})();
